/*
频道配置信息
path: 即路由的path，对应的路径为 /alias
component: 页面组件，对应的路径为 @/pages/component
一些独立存在的栏目：
纪念奖项中的相关新闻： jiangxiangxinwen
*/
var channels = [
  {
    name: '新闻动态',
    alias: 'xinwen',
    path: '/xinwen',
    banner: 'banner-xinwen.jpg',
    component: 'xinwen',
    children:[
      {
        name: '全部',
        alias: 'all'
      },
      {
        name: '综合报道',
        alias: 'zonghebaodao'
      },
      {
        name: '参观交流',
        alias: 'canguanjiaoliu'
      },
      {
        name: '报告论坛',
        alias: 'baogaoluntan'
      },
      {
        name: '纪念捐赠',
        alias: 'jinianjuanzeng'
      },
      {
        name: '事迹展演',
        alias: 'shijizhanyan'
      },
      {
        name: '纪念奖项相关动态',
        alias: 'jiangxiangxinwen'
      }
    ]
  },
  {
    name: '王选生平',
    alias: 'shengping',
    path: '/shengping',
    banner: 'banner-shengping.jpg',
    component: 'shengping',
    children:[
      {
        name: '生平介绍',
        alias: 'shengpingjieshao'
      },
      {
        name: '王选年谱',
        alias: 'wangxuannianpu'
      },
      {
        name: '永恒瞬间',
        alias: 'yonghengshunjian',
        children:[
          {
            name: '青年时代',
            alias: 'qingnianshidai'
          },
          {
            name: '80年代',
            alias: '80niandai'
          },
          {
            name: '90年代',
            alias: '90niandai'
          },
          {
            name: '世纪风采',
            alias: 'shijifengcai'
          },
        ]
      },
      {
        name: '题词手稿',
        alias: 'ticishouji',
        children:[
          {
            name: '手稿',
            alias: 'shouji'
          },
          {
            name: '题词',
            alias: 'tici'
          },
        ]
      },
    ]
  },
  {
    name: '成就荣誉',
    alias: 'rongyu',
    path: '/rongyu',
    banner: 'banner-rongyu.jpg',
    component: 'rongyu',
    children:[
      {
        name: '科技成就',
        alias: 'kejichengjiu'
      },
      {
        name: '所获专利',
        alias: 'suohuozhuanli'
      },
      {
        name: '荣誉奖励',
        alias: 'rongyujiangli'
      },
    ]
  },
  {
    name: '王选文萃',
    alias: 'wencui',
    path: '/wencui',
    banner: 'banner-wencui.jpg',
    component: 'wencui',
    children:[
      {
        name: '回忆激光照排',
        alias: 'jiguangzhaopai'
      },
      {
        name: '论科研与创新',
        alias: 'keyanchuangxin'
      },
      {
        name: '论技术与市场',
        alias: 'jishushichang'
      },
      {
        name: '论高科技企业',
        alias: 'kejiqiye'
      },
      {
        name: '论教育与人才',
        alias: 'jiaoyurencai'
      },
      {
        name: '论时事与人文',
        alias: 'shishirenwen'
      },
      {
        name: '王选经典语录',
        alias: 'jingdianyulu'
      },
    ]
  },
  {
    name: '宣传纪念',
    alias: 'xuanchuan',
    path: '/xuanchuan',
    banner: 'banner-jinian.jpg',
    component: 'xuanchuan',
    children:[
      {
        name: '追思缅怀',
        alias: 'zhuisimianhuai'
      },
      {
        name: '回忆综述',
        alias: 'huiyizongshu'
      },
      {
        name: '事迹报告',
        alias: 'shijibaogao'
      },
      {
        name: '研究出版',
        alias: 'yanjiuchuban'
      },
      {
        name: '纪念奖项',
        alias: 'jinianjiangxiang'
      },
    ]
  },
  {
    name: '纪念陈列室',
    alias: 'chenlieshi',
    path: '/chenlieshi',
    banner: 'banner-chenlieshi.jpg',
    component: 'chenlieshi',
    children:[
      {
        name: '陈列室简介',
        alias: 'chenlieshijianjie'
      },
      {
        name: '展馆陈列',
        alias: 'zhanguanchenlie'
      },
      {
        name: '陈列室动态',
        alias: 'chenlieshidongtai'
      },
      {
        name: '预约参观',
        alias: 'yuyuecanguan'
      },
      {
        name: '陈列室全景',
        alias: 'quanjing',
        type: 2,
        link: "https://wangxuan.pku.edu.cn/quanjing/tour.html"
      },
      {
        name: '生平事迹展',
        alias: 'wxvr',
        type: 2,
        link: "https://wangxuan.pku.edu.cn/wxvr/"
      },
    ]
  },
  {
    name: '影音展播',
    alias: 'yingyin',
    path: '/yingyin',
    banner: 'banner-yingyin.jpg',
    component: 'yingyin',
    children:[
      {
        name: '人物专题',
        alias: 'renwuzhuanti'
      },
      {
        name: '宣传报道',
        alias: 'xuanchuanbaodao'
      },
    ]
  },

];

 // 版块名称
 var blockAlias = {        
    BLOCK_ALIAS_XINWENDONGTAI: 'xinwendongtai',
    BLOCK_ALIAS_YINGYINZHANBO: 'yingyinzhanbo',
    BLOCK_ALIAS_WANGXUANWENCUI: 'wangxuanwencui',
    BLOCK_ALIAS_JIGUANGZHAOPAI: 'jiguangzhaopai',
    BLOCK_ALIAS_KEYANCHUANGXIN: 'keyanchuangxin',
    BLOCK_ALIAS_JISHUSHICHANG: 'jishushichang',
    BLOCK_ALIAS_KEJIQIYE: 'kejiqiye',
    BLOCK_ALIAS_JIAOYURENCAI: 'jiaoyurencai',
    BLOCK_ALIAS_SHISHIRENWEN: 'shishirenwen',
    BLOCK_ALIAS_XUANCHUANJINIAN: 'xuanchuanjinian',
    BLOCK_ALIAS_ZHUISIMIANHUAI: 'zhuisimianhuai',
    BLOCK_ALIAS_HUIYIZONGSHU: 'huiyizongshu',
    BLOCK_ALIAS_BAOGAOZONGSHU: 'baogaozongshu',
    BLOCK_ALIAS_YANJIUCHUBAN: 'yanjiuchuban',
    BLOCK_ALIAS_ZHANGUANCHENLIE: 'zhanguanchenlie',
    BLOCK_ALIAS_RENWUZHUANTI: 'renwuzhuanti',
    BLOCK_ALIAS_XUANCHUANBAODAO: 'xuanchuanbaodao',
}

function getChannel(alias){
  let channel = null;
  channels.forEach(item =>{
    if(item.alias == alias){
      channel = item;
      return;
    }
    // 查找子节点
    if(item.children != null){
      item.children.forEach(citem=>{
        if(citem.alias == alias){
          channel = citem;
          return;
        }
      });
    }
  });
  return channel;
}

function getChannelPath(alias){
  let path = "/";
  channels.forEach(item =>{
    if(item.alias == alias){
      path = "/" + item.alias;
      return path;
    }
    // 查找子节点
    if(item.children != null){
      item.children.forEach(citem=>{
        if(citem.alias == alias){
          path = "/" + item.alias + "?tab=" + citem.alias;
          return path;
        }
      });
    }
  }); 
  return path; 
}

export {
  channels,
  blockAlias,
  getChannel,
  getChannelPath,
};



// WEBPACK FOOTER //
// ./src/config/channels.js